import { z as i } from "./lit-element-6iugfgmM.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { I: l } = i, v = (t) => t.strings === void 0, a = () => document.createComment(""), B = (t, o, n) => {
  var e;
  const s = t._$AA.parentNode, _ = o === void 0 ? t._$AB : o._$AA;
  if (n === void 0) {
    const $ = s.insertBefore(a(), _), r = s.insertBefore(a(), _);
    n = new l($, r, t, t.options);
  } else {
    const $ = n._$AB.nextSibling, r = n._$AM, f = r !== t;
    if (f) {
      let A;
      (e = n._$AQ) == null || e.call(n, t), n._$AM = t, n._$AP !== void 0 && (A = t._$AU) !== r._$AU && n._$AP(A);
    }
    if ($ !== _ || f) {
      let A = n._$AA;
      for (; A !== $; ) {
        const c = A.nextSibling;
        s.insertBefore(A, _), A = c;
      }
    }
  }
  return n;
}, g = (t, o, n = t) => (t._$AI(o, n), t), m = {}, p = (t, o = m) => t._$AH = o, x = (t) => t._$AH, b = (t) => {
  var s;
  (s = t._$AP) == null || s.call(t, !1, !0);
  let o = t._$AA;
  const n = t._$AB.nextSibling;
  for (; o !== n; ) {
    const _ = o.nextSibling;
    o.remove(), o = _;
  }
};
export {
  v as f,
  b as h,
  p as m,
  x as p,
  B as r,
  g as v
};
//# sourceMappingURL=directive-helpers-B5UsscjS.js.map
